module.exports = __webpack_public_path__ + "img/logo-fysiotherapieplus.64c7f133.jpg";